import { render, staticRenderFns } from "./productConfiguration.vue?vue&type=template&id=12c8e2b0&scoped=true&"
import script from "./productConfiguration.vue?vue&type=script&lang=js&"
export * from "./productConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./productConfiguration.vue?vue&type=style&index=0&id=12c8e2b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8e2b0",
  null
  
)

export default component.exports